import { Pipe, PipeTransform } from "@angular/core";
import { getApprovalRejectedProductRequestItemCount } from "../helpers/get-approval-rejected-product-request-item-count";
import { ProductRequest } from "../models/ProductRequest";

@Pipe({name: 'approvalRejectedProductRequestItemCount'})
export class ApprovalRejectedProductRequestItemCountPipe implements PipeTransform {
  transform(value: ProductRequest): number {
    return getApprovalRejectedProductRequestItemCount(value);
  }
}